import styled from "styled-components";
import LogoMca from "../../../assets/images/mca-lab-transparent.png"

export const Title = styled("h3")`
  margin: 45px 0px 30px;
  font-size: 20px;
  color: #182028;
`;

export const ProfileContainer = styled("div")`
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 3rem;
`;

export const ImageContainer = styled("div")<{ imageUrl }>`
  background-image: url(${({ imageUrl }) => imageUrl || LogoMca});
  background-color: white;
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  border-radius: 100%;
  height: 15rem;
  width: 15rem;
  margin-bottom: 2rem;
`;

export const UserInformationContainer = styled("div")`
  text-align: center;
  overflow: hidden;
  text-overflow: ellipsis;
  max-height: 5rem;
  max-width: 70%;
`;

export const Badget = styled("span")`
  display: inline-block;
  padding: 1rem;
  line-height: 1;
  color: white;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: 0.3rem;
  background-color: #D9D9D9;
  padding: 0.3rem 0.6rem;
  margin: 0.5rem;
`;